import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=2fc29df0&scoped=true"
import script from "./attention.vue?vue&type=script&lang=js"
export * from "./attention.vue?vue&type=script&lang=js"
import style0 from "./attention.vue?vue&type=style&index=0&id=2fc29df0&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc29df0",
  null
  
)

export default component.exports